import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth';

export const authGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  // Wait for authentication check to complete
  await authService.checkAuth();

  if (authService.currentUser()) {
    return true;
  }

  // Store the intended URL so we can redirect after login
  localStorage.setItem('redirectAfterLogin', state.url);

  // Redirect to home if not authenticated
  router.navigate(['/']);
  return false;
};
